<template>
  <div>
    <div class="card mt-3">
      <form @submit.prevent='addUser'>
      <div>
        <b>Add User</b>
      </div>
      <div>
        <label for="last" class="prompt">Last: </label>
        <input
          type="text"
          id="last"
          name="last"
          autocomplete="off"
          v-model='newUser.last'
          v-on:input="debouncedHandler"
          placeholder="search 2 chars or more"
        />
      </div>
      <div>
        <label for="first" class="prompt">First: </label>
        <input
          type="text"
          id="first"
          name="first"
          autocomplete="off"
          v-model='newUser.first'
          v-on:input="debouncedHandler"
          placeholder="search 1 char or more"
        />
      </div>
      <div>
        <label for="username" class="prompt">Username: </label>
        <select
          id="username"
          name="username"
          v-model='newUser.username'
          @change="onChangeUser($event)"
        >
        <option value="" disabled selected>-- pick username --</option>
        <option v-for="s in search" :key="s.username" :value="s.username">
          {{ s.last }}, {{ s.first }} {{ s.username }}
        </option>
        </select>
        </div>
        <div>
        <label for="displayname" class="prompt">Displayname:</label>
        <input
          type="text"
          id="displayname"
          name="displayname"
          autocomplete="off"
          v-model='newUser.displayname'
          maxlength="3"
        />
        </div>
        <div>
          <label for="role" class="prompt">Role: </label>
        <select
          id="role"
          name="role"
          v-model='newUser.role'
        >
        <option value="" disabled selected>-- pick role --</option>
        <option v-for="role in roles" :key="role">
          {{ role }}
        </option>
        </select>
        </div>
        <div :style="{backgroundColor: newUser.color}">
          <label for="color" class="prompt">Color: </label>
        <select
          id="color"
          name="color"
          v-model='newUser.color'
          @change="onChangeColor($event)"
        >
        <option value="" disabled selected>-- pick color --</option>
        <option v-for="c in colors" :key="c.hex" :value="c.hex">
          {{ c.name }}
        </option>
        </select>
      </div>
      <div>
        <label for="admin" class="prompt">Site Admin: </label>
        <input type="checkbox" id="admin" v-model="checked" class="field" />
      </div>
        <div>
          <input type="submit" />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { mapGetters } from 'vuex'

export default {
  name: 'UserForm',
  data () {
    return {
      newUser: {
        username: '',
        role: '',
        displayname: '',
        color: '',
        last: '',
        first: '',
        siteid: this.$route.params.siteid
      }
    }
  },
  computed: {
    ...mapGetters(['users', 'search', 'roles', 'colors'])
  },
  methods: {
    addUser () {
      this.$store.dispatch('putUser', this.newUser)
    },
    onChangeUser (event) {
      console.log(event.target.value)
      var userObj = this.$store.getters.search.filter((item) => item.username === event.target.value)
      this.newUser.first = userObj[0].first
      this.newUser.last = userObj[0].last
      this.newUser.displayname = userObj[0].displayname
    },
    onChangeColor (event) {
      console.log(event.target.value)
    }
  },
  created () {
    this.debouncedHandler = debounce(event => {
      console.log('New value:', event.target.value)
      if ((this.newUser.first.length > 0) && (this.newUser.last.length > 1)) {
        this.$store.dispatch('searchUser', { first: this.newUser.first, last: this.newUser.last })
      }
    }, 600)
  },
  beforeUnmount () {
    this.debouncedHandler.cancel()
  }
}

</script>
<style scoped>
  .prompt {
    display: inline-block;
    width: 100px;
    text-align: right;
  }
  .border {
     border: 1px solid black;
     padding: 1px;
  }
  select {
      width: 150px;
  }
  .vertical {
    writing-mode: vertical-lr;
  }
</style>
